import { create } from 'zustand';

type State = {
  screeningQuestionsLength: number;
  screeningAnswersLength: number;
};

type Action = {
  setScreeningQuestionsLength: (value: number) => void;
  setScreeningAnswersLength: (value: number) => void;
};

const useScreeningQuestionsStore = create<State & Action>((set) => ({
  screeningQuestionsLength: 1,
  setScreeningQuestionsLength: (value: number) => set({ screeningQuestionsLength: value }),

  screeningAnswersLength: 3,
  setScreeningAnswersLength: (value: number) => set({ screeningAnswersLength: value }),
}));

export default useScreeningQuestionsStore;
